<template>
    <app-layout>
        <template #header>
            <div class="relative">
                <div class="absolute top-0 right-0">
                    <inertia-link
                        class="bg-gray-300 hover:bg-gray-500 text-black py-1 px-3 mx-3 rounded my-0"
                        :href="route('extract.index')">
                        <i class="fas fa-arrow-left mx-1"></i> Extrato
                    </inertia-link>
                    <button
                        @click="print()"
                        class="bg-green-500 text-sm hover:bg-green-700 text-white text-base font-bold my-0 -mt-10 py-3 px-6 rounded">
                        Imprimir
                    </button>
                </div>
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    Transferência entre contas
                </h2>
            </div>
        </template>
        <div>
            <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
                <flash :timeout="5000"/>

                <template>
                    <jet-form-section>
                        <template #title>
                            Comprovante de transferência
                        </template>

                        <template #description>
                        </template>

                        <template #form>
                            <div class="col-span-6 sm:col-span-3">
                                <ticket :account="account" :content="content"/>
                            </div>
                        </template>
                    </jet-form-section>
                </template>

                <jet-section-border/>

            </div>

        </div>

    </app-layout>
</template>

<script>
import AppLayout from './../../Layouts/AppLayout'
import JetSectionBorder from './../../Jetstream/SectionBorder'
import JetActionMessage from "../../Jetstream/ActionMessage";
import JetButton from "../../Jetstream/Button";
import JetFormSection from "../../Jetstream/FormSection";
import JetOkButton from "../../Jetstream/OkButton";
import Flash from "../../Helpers/Flash"
import Ticket from "./Ticket";

export default {
    props: ['transfer', 'account', 'errors'],
    methods: {
        print() {
            const prtHtml = document.getElementById('transfer-receipt').innerHTML;
            let stylesHtml = '';
            for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
                stylesHtml += node.outerHTML;
            }
            const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            WinPrint.document.write(`<!DOCTYPE html><html><head>${stylesHtml}</head><body><div style="width: 300px">${prtHtml}</div></body></html>`);
            WinPrint.document.close();
            WinPrint.focus();
            setTimeout(() => {
                WinPrint.print()
                WinPrint.close();
            }, 2000);
        }
    },
    data() {
        return {
            content: {
                data: this.transfer.content
            },
            reviewTransfer: false,
        }
    },
    components: {
        AppLayout,
        Flash,
        JetSectionBorder,
        JetActionMessage,
        JetButton,
        JetFormSection,
        JetOkButton,
        Ticket
    },
}
</script>
